export const TOGGLE_SNIPPETS = 'TOGGLE_SNIPPETS';
export const AUTOCOMLETION = 'AUTOCOMLETION';
export const LIVEAUTOCOMPLETION = 'LIVEAUTOCOMPLETION';
export const FONTSIZE = 'FONTSIZE';
export const SHOWGUTTER = 'SHOWGUTTER';
export const HIGHLIGHTACTIVELINE = 'HIGHLIGHTACTIVELINE';
export const SHOWPRINTMARGIN = 'SHOWPRINTMARGIN';
export const CHANGE_THEME = 'CHANGE_THEME';